'use strict';
import classNames from 'classnames';
import get from 'lodash/get';
import * as T from 'prop-types';
import React from 'react';
import {Button} from '../../../components/buttons/Button';
import {I18nComponent} from '../../../core-utilities/react-i18n';


export function BaseAssetViewBannerView(props) {
  const asset = props.asset;
  const name = get(asset, 'name', get(asset, 'identifier'));
  const identifier = get(asset, 'identifier') !== name ? get(asset, 'identifier') : null;
  const tempGeo = get(asset, 'geo') ? get(asset, 'geo') : null;

  let address;
  try {
    address = tempGeo.properties.address;
  } catch (e) {
    address = null;
  }

  return (
    <div className={classNames("AssetViewBanner", props.className)}>
      <div className="AssetViewBanner__header">
        <h1 className="AssetViewBanner__headerLabel">
          {name}
        </h1>

        <div className="AssetViewBanner__statusSection">
          <Button
            className="AssetViewBanner__editButton"
            label={props.editLabel}
            onClick={props.onClickEdit}
          />
        </div>

        {identifier && (
          <span className="AssetViewBanner__description">
            {identifier}
          </span>
        )}
        {address && (
          <span className="AssetViewBanner__description">
            {`Address: ${address}`}
          </span>
        )}
      </div>
    </div>
  );
}

BaseAssetViewBannerView.propTypes = {
  className: T.string,
  userId: T.string.isRequired,
  asset: T.object,

  onClickEdit: T.func.isRequired,

  editLabel: T.string,

  init: T.bool,
};

BaseAssetViewBannerView.defaultProps = {
  init: true,
};

export const AssetViewBannerView = I18nComponent(BaseAssetViewBannerView, [
  {code: 'default.button.edit.label', prop: 'editLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/assets/components/AssetViewBanner/AssetViewBannerView.js